<template>
	<v-container class="header-summary-section pa-0">
		<span v-if="headerData.length > 0" class="header-summary-section-label">
			{{ axisLabel }}
		</span>
		<v-row
			v-for="(row, index) in headerData"
			:key="index"
			class="d-flex justify-end ma-0 px-2 py-0 header-data-row position-relative"
		>
			<v-col cols="6" class="position-relative">
				<v-tooltip
					v-if="row.overridden"
					location="top"
					text="This header value is overridden by cell data"
				>
					<template #activator="{ props }">
						<v-icon
							v-bind="props"
							size="x-small"
							color="info"
							tabindex="-1"
							class="position-absolute"
							style="left: -8px; top: 50%; transform: translateY(-50%)"
						>
							mdi-information-outline
						</v-icon>
					</template>
				</v-tooltip>
				<div :class="{ 'value-overridden': row.overridden }">
					{{ row.value }}
				</div>
			</v-col>
			<v-col cols="6" :class="{ 'value-overridden': row.overridden }">
				{{ row.tag.name }}
			</v-col>
			<v-divider v-if="index < headerData.length - 1"></v-divider>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: "VMetadataTableHeaderSummary",

	inject: [],

	props: {
		axisLabel: { type: String, default: "" },
		headerData: { type: Array, default: () => [] },
	},

	emits: [],

	setup() {},

	data() {
		return {};
	},
	computed: {},

	methods: {},
};
</script>

<style lang="scss" scoped>
.header-data-row {
	font-size: 14px;
}

.header-summary-section {
	max-height: 300px;
	overflow-y: auto;
	padding-right: 8px;
}

.header-summary-section-label {
	font-weight: 525;
	font-size: 15px;
}

.value-overridden {
	text-decoration: line-through;
	color: #9e9e9e !important;
	opacity: 0.6;
	pointer-events: none;
}
</style>
